import { Link } from 'react-router'
import styled from 'styled-components'
import { overloadColor } from '@/utils/style'

interface PlainLinkProps {
  $block?: boolean
  $fullWidth?: boolean
  $hoverUnderline?: boolean
  $hoverColor?: string
  $color?: string
}

export const PlainLink = styled(Link)<PlainLinkProps>`
  ${props => props.$block && 'display: block;'}
  ${props => props.$fullWidth && 'width: 100%;'}

  color: ${props =>
    props.$color ? overloadColor(props.$color) + ' !important' : 'inherit'};

  &:hover {
    text-decoration: ${props => (props.$hoverUnderline ? 'underline' : 'none')};
    color: ${props => overloadColor(props.$hoverColor)};
  }
`
